import React, { useEffect, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { rt } from "../i18n/runtime";

/**
 * OfflineBanner
 * Uygulama üstünde sabit, küçük, soluk yanıp sönen offline uyarısı.
 * navigator.onLine + online/offline event listener ile otomatik açılıp kapanır.
 */
export default function OfflineBanner() {
  const { lang } = useLanguage(); // eslint-disable-line no-unused-vars
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOnline  = () => setIsOffline(false);
    const goOffline = () => setIsOffline(true);
    window.addEventListener("online",  goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online",  goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="offlineBanner" role="status" aria-live="polite">
      <span className="offlineBannerDot" aria-hidden="true" />
      <span className="offlineBannerText">{rt("offline.banner")}</span>
    </div>
  );
}
